(() => {
  const dialog = document.getElementById('WsExitOffer');
  if (!dialog || typeof dialog.showModal !== 'function') return;

  const code = dialog.querySelector('input');
  const copy = dialog.querySelector('[data-offer-copy]');
  const status = dialog.querySelector('[role="status"]');
  const preview = window.Shopify?.theme?.role === 'unpublished' &&
    new URLSearchParams(location.search).get('ws_exit_preview') === '1';
  const desktop = matchMedia('(hover: hover) and (pointer: fine) and (min-width: 1024px)');
  const sessionKey = 'ws-resta3-seen';
  const dismissKey = 'ws-resta3-dismissed';
  const cooldown = 3 * 24 * 60 * 60 * 1000;
  const enteredAt = performance.now();
  let interacted = false;
  let shown = false;
  let copying = false;
  let previousFocus = null;

  function preferencesAllowed() {
    return window.Shopify?.customerPrivacy?.currentVisitorConsent?.().preferences === 'yes';
  }

  function suppressed() {
    if (shown) return true;
    try {
      if (sessionStorage.getItem(sessionKey)) return true;
      if (preferencesAllowed() && Date.now() - Number(localStorage.getItem(dismissKey) || 0) < cooldown) return true;
    } catch (_) { /* In-memory frequency cap remains effective when storage is unavailable. */ }
    return false;
  }

  function visible(node) {
    return node && node.getClientRects().length > 0 &&
      getComputedStyle(node).visibility !== 'hidden' && getComputedStyle(node).display !== 'none';
  }

  function foregroundBusy() {
    if (document.body.matches('.ws-chat-open, .search-open, .modal-show, .modal-showing')) return true;
    if (document.querySelector('dialog[open], cart-drawer[open], cart-addon-modal[open], drawer-component[open], predictive-search.predictive-search-open')) return true;
    return Array.from(document.querySelectorAll('#shopify-pc__banner, #shopify-pc__prefs, [role="dialog"][aria-modal="true"], #ws-geo-toast.is-visible')).some(visible);
  }

  function show() {
    if (document.visibilityState !== 'visible' || foregroundBusy()) return;
    if (!preview && (!desktop.matches || !interacted || performance.now() - enteredAt < 30000 || suppressed())) return;
    if (shown) return;
    status.textContent = '';
    previousFocus = document.activeElement;
    dialog.showModal();
    window.FoxTheme.a11y.trapFocus(dialog, copy);
    shown = true;
    if (!preview) {
      try { sessionStorage.setItem(sessionKey, '1'); } catch (_) { /* No persistent dependency. */ }
    }
  }

  document.addEventListener('pointerdown', () => { interacted = true; }, { once: true, passive: true });
  document.addEventListener('keydown', () => { interacted = true; }, { once: true });
  document.addEventListener('scroll', () => { interacted = true; }, { once: true, passive: true });
  document.addEventListener('mouseout', (event) => {
    if (!event.relatedTarget && event.clientY <= 0 && event.clientX > 0 && event.clientX < innerWidth) show();
  });

  dialog.querySelectorAll('[data-offer-close]').forEach(button => {
    button.addEventListener('click', () => dialog.close());
  });
  dialog.addEventListener('click', (event) => {
    if (event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
  });
  dialog.addEventListener('close', () => {
    window.FoxTheme.a11y.removeTrapFocus(previousFocus);
    if (!preview && preferencesAllowed()) {
      try { localStorage.setItem(dismissKey, String(Date.now())); } catch (_) { /* Session cap still applies. */ }
    }
  });
  code.addEventListener('click', () => code.select());
  copy.addEventListener('click', async () => {
    if (copying) return;
    copying = true;
    try {
      await navigator.clipboard.writeText(code.value);
      status.textContent = dialog.dataset.copied;
    } catch (_) {
      code.focus();
      code.select();
      status.textContent = dialog.dataset.manual;
    } finally {
      copying = false;
    }
  });

  // Explicit draft-only visual preview; does not consume the customer's frequency cap.
  if (preview) {
    setTimeout(show, 1000);
    document.addEventListener('pointerup', () => setTimeout(show, 350), { passive: true });
  }
})();
